import loans_en from './en.json';
import loans_fr from './fr.json';
import loans_de from './de.json';

const flatten = data => {
    let result = {};

    function recurse(cur, prop) {
        if (Object(cur) !== cur) {
            result[prop] = cur;
        } else if (Array.isArray(cur)) {
            let l;
            for (let i = 0, l = cur.length; i < l; i++)
                recurse(cur[i], prop + '[' + i + ']');
            if (l === 0) result[prop] = [];
        } else {
            let isEmpty = true;
            for (let p in cur) {
                isEmpty = false;
                recurse(cur[p], prop ? prop + '.' + p : p);
            }
            if (isEmpty && prop) result[prop] = {};
        }
    }

    recurse(data, '');
    return result;
};

const _messages = {
    en: flatten(loans_en),
    fr: flatten(loans_fr),
    de: flatten(loans_de)
};

const messages = lang => _messages[lang || navigator.language.split(/[-_]/)[0]];

export default messages;